import React from 'react';

import { ChatSourceProvider } from '~/components/AiChat/contexts/ChatSourceContext';
import { ClaimChatControllerProvider } from '~/components/AiChat/controller/useClaimChatController';

import { FullScreenChatLayout } from './FullScreenChatLayout';

/** The claim's full-screen chat. */
export const FullScreenChat: React.FC = () => (
  <ChatSourceProvider source="full_screen">
    <ClaimChatControllerProvider>
      <FullScreenChatLayout />
    </ClaimChatControllerProvider>
  </ChatSourceProvider>
);

export default FullScreenChat;
